import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ChangePassword from '../components/ChangePassword';

const Profile: React.FC = () => {
    const { user } = useAuth();
    const [changePasswordOpen, setChangePasswordOpen] = useState(false);

    return (
        <div className="p-6">
            <div className="mb-6">
                <h1 className="text-3xl font-semibold text-gray-800">My Profile</h1>
                <p className="text-gray-600 mt-2">Manage your account settings and preferences</p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6">
                <div className="space-y-6">
                    <div>
                        <h3 className="text-lg font-medium text-gray-900 mb-4">Account Information</h3>
                        <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                            <div>
                                <dt className="text-sm font-medium text-gray-500">Full Name</dt>
                                <dd className="mt-1 text-sm text-gray-900">{user?.fullName || 'Not set'}</dd>
                            </div>
                            <div>
                                <dt className="text-sm font-medium text-gray-500">Email Address</dt>
                                <dd className="mt-1 text-sm text-gray-900">{user?.email}</dd>
                            </div>
                            <div>
                                <dt className="text-sm font-medium text-gray-500">Role</dt>
                                <dd className="mt-1">
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 capitalize">
                                        {user?.role}
                                    </span>
                                </dd>
                            </div>
                            <div>
                                <dt className="text-sm font-medium text-gray-500">Department</dt>
                                <dd className="mt-1 text-sm text-gray-900">{user?.department || 'Not assigned'}</dd>
                            </div>
                            <div>
                                <dt className="text-sm font-medium text-gray-500">Status</dt>
                                <dd className="mt-1">
                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                        user?.status === 'active' 
                                            ? 'bg-green-100 text-green-800' 
                                            : 'bg-gray-100 text-gray-800'
                                    }`}>
                                        {user?.status}
                                    </span>
                                </dd>
                            </div>
                        </dl>
                    </div>

                    <div className="pt-6 border-t border-gray-200">
                        <h3 className="text-lg font-medium text-gray-900 mb-4">Security</h3>
                        <button 
                            onClick={() => setChangePasswordOpen(true)}
                            className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            Change Password
                        </button>
                    </div>

                    <div className="pt-6 border-t border-gray-200">
                        <h3 className="text-lg font-medium text-gray-900 mb-4">Desktop Agent</h3>
                        <p className="text-sm text-gray-600 mb-4">
                            Download and install the Depot Sync desktop agent to automatically sync files from your computer.
                        </p>
                        <a 
                            href="/public_files/edms-sync-setup.exe"
                            download
                            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <svg className="mr-2 -ml-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                            </svg>
                            Download Desktop Agent (Windows)
                        </a>
                        <p className="text-xs text-gray-500 mt-2">
                            Version 1.0.0 • Compatible with Windows 10/11
                        </p>
                    </div>
                </div>
            </div>
            
            {/* Change Password Dialog */}
            <ChangePassword 
                open={changePasswordOpen}
                onClose={() => setChangePasswordOpen(false)}
                onSuccess={() => {
                    setChangePasswordOpen(false);
                    // Password changed successfully
                }}
            />
        </div>
    );
};

export default Profile;